export default "__VITE_ASSET__3c8ee6c1__"